import { format, sub } from 'date-fns';
import { EventFeedEvent, MarketOverview, marketOverview } from '@toggle/toggle';

import { wretchRequest } from '~/utils/api-fetch/apiFetch';

const MARKET_OVERVIEW_PERIOD_DAYS = 15;

export const fetchMarketOverviewInsights = async (
  pageNumber: number,
  signal?: AbortSignal
): Promise<MarketOverview> => {
  const daysToSubtract = MARKET_OVERVIEW_PERIOD_DAYS * pageNumber;
  const fromDate = format(
    sub(new Date(), { days: daysToSubtract }),
    'yyyy-MM-dd'
  );

  return wretchRequest<MarketOverview>(
    marketOverview.getMarketOverview.path({ fromDate }),
    {
      schema: marketOverview.getMarketOverview.schema,
      signal,
    }
  );
};

export const enrichEventsWithMarketOverviewInsights = (
  events: EventFeedEvent[],
  marketOverviewData?: MarketOverview
): EventFeedEvent[] => {
  if (!marketOverviewData?.summaries?.length) {
    return events;
  }

  const summariesMap = new Map(
    marketOverviewData.summaries.map(summary => [summary.id, summary])
  );

  return events.map(event => {
    if (event.type !== 'market-overview') {
      return event;
    }

    const matchingSummary = summariesMap.get(event.source_id);
    if (!matchingSummary) {
      return event;
    }

    return {
      ...event,
      summary: matchingSummary.summary,
      metadata: {
        ...event.metadata,
        questions: matchingSummary.questions,
      },
    };
  });
};
